import { render, staticRenderFns } from "./RelatorioPerformanceRegiaoFiltroModalItemInputFornecedor.vue?vue&type=template&id=53048f27"
import script from "./RelatorioPerformanceRegiaoFiltroModalItemInputFornecedor.vue?vue&type=script&lang=js"
export * from "./RelatorioPerformanceRegiaoFiltroModalItemInputFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports